const className = 'ScreenType'

export default class ScreenType {
  constructor (Parse) {
    this.Parse = Parse
  }

  /**
   * Get a ScreenType query to find all screentypes
   */
  getAll() {
    var Class = this.Parse.Object.extend(className)
    var query = new this.Parse.Query(Class)
    query.include('data')
    return query
  }
}


//////////////////
// WEBPACK FOOTER
// ./parse-model/ScreenType.mjs
// module id = Xs2P
// module chunks = 0